<script setup lang="ts">
import { ChipButton } from '../chip/'
import { IconPlus, IconCheck } from '@caks/uikit/icon/'
import { useAccountStore } from '@caks/shared/store/store.account'
import { computed, onMounted, shallowRef } from 'vue'
import { FoodExtraModification, FoodItem } from '@caks/shared/types/types.api'
import { CartItem, SelectedModificator } from '@caks/shared/types/types.user'
import { getFoodItemInfo } from '@caks/shared/api/user.route'
import { useHaptic } from '@caks/shared/composables/useHaptic'
import { Capacitor } from '@capacitor/core'

interface Props {
  food: {
    id: number
    main_media: string
    medias: Array<string>
    name: string
    description: string
    available_modifications: {
      base_modifications: Array<{
        id: number
        name: string
        available_variants: Array<{
          id: number
          name: string
        }>
      }>
      extra_modifications: Array<{
        id: number
        name: string
        image: string
        cost: number
      }>
      ingredients: Array<{
        id: number
        name: string
        required: boolean
      }>
      removable_modifications: Array<{
        id: number
        name: string
        required: boolean
      }>
    }
    base_cost: number
    base_bju: {
      kkal: number
    }
  }
  desktop: boolean
}

interface Emit {
  (e: 'addToCart', food: Object): void
  (e: 'beforeRouterPush', food: Object): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emit>()
const router = useRouter()
const store = useAccountStore()
const isAddedToCart = ref(false)

const description = shallowRef<string>('')
const modal = ref<ModalElement>()

onMounted(() => {
  let tempString = ''

  let base = props.food.available_modifications.base_modifications
  for (let i = 0; i < base.length; i++) {
    tempString += base[i].name + ', '
  }

  let imgredients = props.food.available_modifications.ingredients
  for (let i = 0; i < imgredients.length; i++) {
    tempString += imgredients[i].name + ', '
  }

  description.value = tempString[0] + tempString.slice(1, tempString.length - 2).toLowerCase()
})

const onFoodClick = () => {
  if (!isNotStopList.value) return

  emit('beforeRouterPush', props.food)

  router.push(props.desktop ? '' : `food/${props.food.id}`)
}

const selectedBaseMods = ref<SelectedModificator[]>([])
const allFoodInfo = shallowRef<FoodItem | null>(null)
const extraIngredientsSelected = ref<FoodExtraModification[]>([])
const removedCheckboxList = ref<number[]>([])
const removableList = computed(() => {
  return allFoodInfo.value?.available_modifications.removable_modifications
})
const removedList = computed(() => {
  if (removableList.value) {
    return removableList.value.filter((el) => {
      return removedCheckboxList.value.includes(el.id)
    })
  }
  return []
})

// Оптимизировать
const addToCart = async (foodId: number) => {
  let data: any

  //@ts-ignore
  const res = await getFoodItemInfo(foodId)

  if (res.status === 'ERR') throw res.description ?? res.message

  data = res.data[0]

  const baseVariants = (data as FoodItem).available_modifications.base_modifications

  //@ts-ignore
  selectedBaseMods.value = baseVariants.map((el) => {
    return { modification_id: el.id, name: el.name, variant_id: el.available_variants[0].id }
  })

  allFoodInfo.value = data as FoodItem

  allFoodInfo.value.available_modifications.ingredients.sort((a, b) => {
    if (a.required && !b.required) return -1
    if (!a.required && b.required) return 1
    return 0
  })
  if (allFoodInfo.value) {
    const cartExtraMods = extraIngredientsSelected.value.map((el) => {
      return {
        modification_id: el.id,
        name: el.name,
      }
    })
    const cartRemovedMods = removedList.value.map((el) => {
      return {
        modification_id: el.id,
        name: el.name,
      }
    })

    const cartItem: CartItem = {
      item: allFoodInfo.value,
      //@ts-ignore
      extraModificators: cartExtraMods,
      //@ts-ignore
      removedModificators: cartRemovedMods,
      //@ts-ignore
      baseModificators: selectedBaseMods.value,
      cost: allFoodInfo.value.base_cost,
    }

    store.addToCart(cartItem)
    localStorage.setItem('cart', JSON.stringify(store.cart))
  }
}
const onAddItemToCart = async () => {
  isAddedToCart.value = true

  if (Capacitor.isNativePlatform()) {
    await hapticsImpactHeavy()
  }

  setTimeout(() => {
    isAddedToCart.value = false
  }, 700)
}

const { hapticsImpactHeavy } = useHaptic()

const onButtonClick = async (event: MouseEvent) => {
  if (
    props.food.available_modifications.base_modifications.length > 0 ||
    props.food.available_modifications.extra_modifications.length > 0 ||
    props.food.available_modifications.ingredients.length > 0 ||
    props.food.available_modifications.removable_modifications.length > 0
  ) {
    if (props.desktop) {
      onFoodClick()
    }
    return
  }

  if (isAddedToCart.value) {
    event.stopPropagation()
    return
  }
  const isBaseMods = props.food.available_modifications.base_modifications.length
  const inCartItem = store.cart.find((el) => el.item.id === props.food.id)

  console.log('isBaseMods', isBaseMods)

  if (!isBaseMods) {
    event.stopPropagation()

    if (inCartItem) {
      inCartItem.amount++
      localStorage.setItem('cart', JSON.stringify(store.cart))
      onAddItemToCart()
    } else {
      if (store.profile || props.desktop) {
        console.log('newLocation START')
        store.setNeedChangeLocation(true)

        await onAddItemToCart()
        addToCart(props.food.id)
      } else {
        if (!props.desktop) {
          router.push('/auth/phone')
        }
      }
    }
  }
}

const isModificators = computed(() => {
  const isBase = props.food.available_modifications.base_modifications.length
  const isExtra = props.food.available_modifications.extra_modifications.length

  return isBase || isExtra
})

const isNotStopList = computed(() => {
  let result = false
  if (props.food.stock.length === 0) result = true
  else if (props.food.stock[0].balance > 0) result = true
  // else if (props.food.stock[0].terminal_group_id === null) result = true

  return result
})
</script>

<template>
  <article
    class="food"
    :class="{ desktop, mobile: !desktop }"
    @click="onFoodClick"
    :id="props.food.id.replace(/\d/g, '')"
  >
    <div class="food__image">
      <img :src="food.main_media" :alt="food.name" loading="lazy" decoding="async" />
    </div>
    <div class="food__info">
      <h3 class="food__title" v-text="food.name" />
      <p class="food__description" v-text="food.description" />

      <div v-if="desktop" class="food__last-row">
        <div class="food__price">
          <span v-if="isModificators">от </span> {{ `${food.base_cost}₽` }}
        </div>
        <chip-button
          @click.stop="onButtonClick"
          secondary
          style="width: 90px; overflow: hidden; position: relative"
          v-if="isNotStopList"
        >
          <transition-group name="list">
            <div v-if="!isAddedToCart">В корзину</div>
            <icon-check v-else />
          </transition-group>
        </chip-button>
        <chip-button v-else>
          <transition-group name="list">
            <div>Будет позже</div>
          </transition-group>
        </chip-button>
      </div>
      <chip-button v-else @click="onButtonClick" secondary style="width: 110px">
        <template v-if="isNotStopList">
          <transition-group name="list">
            <div v-if="!isAddedToCart" class="button-inner">
              <p><span v-if="isModificators">от </span> {{ `${food.base_cost}₽` }}</p>
              <icon-plus />
            </div>
            <div v-else>
              <icon-check />
            </div>
          </transition-group>
        </template>
        <template v-else>
          <transition-group name="list">
            <div v-if="!isAddedToCart" class="button-inner">
              <p>Будет позже</p>
            </div>
          </transition-group>
        </template>
      </chip-button>
    </div>
  </article>
</template>

<style scoped lang="scss">
.food.mobile {
  display: flex;
  align-items: center;
  padding: 8px 0;
  gap: 4px;
}

.mobile {
  .food {
    &__image {
      height: 128px;
      width: 128px;
      min-width: 128px;
      border-radius: 12px;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    &__info {
      width: 100%;
      height: fit-content;
    }

    &__title {
      @include h4-2;
      color: $primary-text;
    }

    &__description {
      @include h7-1;
      margin: 4px 0 12px;
      color: $sub-text;
    }
  }
}

.desktop.food {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  height: 100%;

  cursor: pointer;
}
.desktop {
  .food {
    &__image {
      height: 260px;
      width: 260px;
      min-width: 260px;
      margin: 0 20px;
      border-radius: 12px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }

    &__info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 20px;
    }

    &__title {
      @include h3-1;
      color: $primary-text;
    }

    &__description {
      @include h5-2;

      color: $sub-text;
    }

    &__last-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__price {
      @include h3-5;
    }
  }
}

.list-move,
.list-enter-active {
  transition: all 0.35s ease;
}

.list-leave-active {
  transition: all 0.35s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
}

.list-leave-active {
  position: absolute;
  left: 20px;
  right: 20px;
  z-index: -1;
}

.button-inner {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
